@if (label) {
  <app-control-header
    [label]="label"
    [icon]="labelIcon"
    [labelParamsObj]="labelParamsObj"
    [index]="index"
    [required]="required"
  ></app-control-header>
}

<div
  class="editor-container"
  [ngClass]="{
    'hover:border-navy-90': focusEnabled,
    'border-navy-90': isFocused,
    'pointer-events-none opacity-50': isDisabled,
    'border-error': errorsDisplayed,
  }"
>
  <quill-editor
    #quillEditor
    id="quill-editor"
    class="editor"
    [style.min-height.px]="minTextareaHeight"
    [formControl]="internalFormControl"
    [placeholder]="placeholder | translate: placeholderParamsObj"
    [modules]="modules"
    [readOnly]="readonly"
    [sanitize]="true"
    [minLength]="minLength"
    [maxLength]="maxLength"
    [required]="required"
    [preserveWhitespace]="preserveWhitespace"
    [bounds]="'#quill-editor'"
    (onEditorCreated)="focusAfterEditorCreated && $event.focus()"
    (onBlur)="blur()"
    (keydown.enter)="enterEnabled && $event.stopPropagation()"
    (onContentChanged)="maxLength && textChanged($event)"
  ></quill-editor>

  @if (displayCharactersCounter) {
    <app-characters-counter
      class="characters-counter"
      [value]="quillEditor.quillEditor?.getText()?.slice(0, -1)"
      [maxLength]="maxLength"
    ></app-characters-counter>
  }
</div>

<div class="errors-container">
  @if (errorsDisplayed) {
    <app-control-errors class="flex-1" [errorTexts]="errorTexts"></app-control-errors>
  }
</div>
